import React from "react";
import preLoader from "../../images/svg/gif-3.gif";
const PreLoader = () => {
  return (
    <div className="preloader">
      <img src={preLoader} alt="" />
    </div>
  );
};

export default PreLoader;
